import React, {Component} from 'react';
import Header from './Shared/Header';
import RussianDisclaimer from './ContactUs/RussianDisclaimer';
import "whatwg-fetch";

class ContactPageContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRussianSite: false
        }
    }

    checkLocationPage() {
        var locationSite = this.props.contactJson.ActiveLocation.Value;
        if(locationSite =="ru-RU") {
            this.setState({
                isRussianSite: true,
            });
        }
    }
    componentWillMount() {
        this.checkLocationPage();
    }

    render() {
        return (
            <div>
                {this.props.contactJson.Sliders.length > 0 ? (
                    <Header topHeader={this.props.contactJson.Sliders[0]} newClassName={"product-index-visual"} />
                ) : null}
                <div className="main">
                    <section className="unsubscribe subscribe clearfix">
                        <section>
                        {this.props.contactJson.Title ? (
                            <h2 className="contactTitle">{this.props.contactJson.Title.Value}</h2>
                        ) : null}
                        {this.props.contactJson.SubTitle ? (
                            <p className="text">{this.props.contactJson.SubTitle.Value}</p>
                        ) : null}
                            <div className="contactgsdb" id="app"></div>
                            {this.state.isRussianSite && <RussianDisclaimer />}
                        </section>
                    </section>

                </div>
            </div>
        )
    }
}

export default ContactPageContent;
